import { createAction, props } from '@ngrx/store';

export const loadOrderValidation = createAction('[Order Validation] Load', props<{ payload: any }>());

export const loadOrderValidationSuccess = createAction('[Order Validation] Load Success', props<{ response: any }>());

export const loadOrderValidationSuccessByKey = createAction(
  '[Order Validation] Load Success By Key',
  props<{ key: string; response: any }>(),
);

export const loadOrderValidationFailure = createAction('[Order Validation] Load Failure', props<{ error: any }>());
